import { RouteConfig } from 'vue-router'
import Layout from '@/layout/index.vue'

export const systemRouter: RouteConfig = {
  path: '/system',
  component: Layout,
  name: 'system',
  meta: {
    title: '平台管理',
    icon: 'component',
    alwaysShow: true,
    access: ['menu:admin']
  },
  children: [
    {
      path: 'index',
      component: () => import('@/views/main/system/system.vue'),
      name: 'index',
      meta: {
        title: '系统管理',
        icon: 'component',
        access: ['menu:admin:system']
      }
    },
    {
      path: 'config',
      component: () => import('@/views/main/system/config.vue'),
      name: 'config',
      meta: {
        title: '配置管理',
        icon: 'component',
        access: ['menu:admin:config']
      }
    },
    {
      path: 'permission',
      component: () => import('@/views/main/system/permission.vue'),
      name: 'permission',
      meta: {
        title: '权限管理',
        icon: 'component',
        access: ['menu:admin:permission']
      }
    },
    {
      path: 'role',
      component: () => import('@/views/main/system/role.vue'),
      name: 'role',
      meta: {
        title: '角色管理',
        icon: 'component',
        access: ['menu:admin:role']
      }
    }
  ]
}
